import React, { useState } from 'react'
import { Helmet } from "react-helmet";
import useDocumentTitle from "../../useDocumentTitle";
import Modal_started from '../Home/Modal_started';
import { Link } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";

const Article_the_key_to_scale_your_commerce_in_sv = () => {

    useDocumentTitle(
        "La clave para escalar tu comercio en El Salvador: Invu POS | Invu POS"  
    ); 

  const [isOpenOptions, setIsOpenOptions] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const prefix = useLocalePrefix();
    
  return (
    <>

    <Helmet>
        <meta
            name="description"
            content="Llevar un negocio en El Salvador no es tarea fácil. Cada día se presentan nuevos retos: adaptarse a los cambios fiscales, gestionar inventarios en múltiples sucursales, ofrecer una experiencia rápida y moderna al cliente, evitar pérdidas internas, controlar al personal, cumplir con normativas… y al mismo tiempo, hacer que el negocio crezca."
        />
        <meta name="keywords" content="La clave para escalar tu comercio en El Salvador: Invu POS" />
    </Helmet>
    {isOpen && <Modal_started setIsOpen={setIsOpen} />}
    <section class="w-full px-4 py-24 mx-auto max-w-7xl md:w-4/5">
    <div class="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
      <div class="col-span-1 md:col-span-2 lg:col-span-2 xl:col-span-3">
        <h1 class="mb-10 text-5xl font-medium text-gray-900 md:text-6xl max-w-5xl" itemprop="headline">
        La clave para escalar tu comercio en El Salvador: Invu POS
        </h1>
      </div>
    </div>
    <div className="max-w-screen-xl mx-auto mt-4">
        <div class="grid flex-col-reverse items-center grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-y-10 md:gap-y-16 gap-x-10 md:gap-x-16">
          <div class="order-none lg:order-2 md:order-none">
          <p className="text-xl text-gray-900 font-light leading-relaxed mb-12">
          Llevar un negocio en El Salvador no es tarea fácil. Cada día se presentan nuevos retos: adaptarse a los cambios fiscales, gestionar inventarios en múltiples sucursales, ofrecer una experiencia rápida y moderna al cliente, evitar pérdidas internas, controlar al personal, cumplir con normativas… y al mismo tiempo, hacer que el negocio crezca.
          </p>
        <div className="flex items-center space-x-2 mt-4 text-gray-500 uppercase text-xs font-semibold">
          <span>By <span className="text-black">Andrés Amaya</span></span>
          <span>&#8212;</span>
          <span>July 22, 2025</span>
          <span>&#8212;</span>
          <span className="text-black">8 MIN READ</span>
        </div>
        <div className="flex space-x-2 mt-4">
          <span className="bg-blue-100 text-black text-xs font-semibold px-3 py-1 rounded">GESTIÓN</span>
          <span className="bg-gray-200 text-black text-xs font-semibold px-3 py-1 rounded">ARTÍCULO</span>
        </div>
        {/* Social Icons */}
        <div className="flex space-x-4 mt-6">
        <div class="flex items-center">
                <div class="flex space-x-6 text-gray-500">
                <a
                  class="hover:opacity-75"
                  href="https://www.instagram.com/invupos/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span class="sr-only"> Instagram </span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </a>

                <a
                  class="hover:opacity-75"
                  href="https://twitter.com/invupos?lang=es"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span class="sr-only"> Twitter </span>
                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>

                <a
                  class="hover:opacity-75"
                  href="https://es-la.facebook.com/invuposofficial/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span class="sr-only"> Facebook </span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </a>
              </div>
              </div>
        </div>
            </div>
            <div className="relative lg:m-auto group flex justify-center h-full w-full">
              <img
                className="object-center object-cover h-full w-full rounded-2xl"
                src="https://img.invupos.com/webinvu/Blog%20invu/la-clave-para-escalar-tu-comercio-en-el-salvador.webp"
                alt=""
              />
            </div>
          </div>
        </div>

        <hr class="my-16 h-0.5 border-t-0 bg-neutral-100" />

        <div className="bg-white flex flex-col md:flex-row justify-center items-start">
      {/* Sidebar - Table of Contents */}
      <div className="w-full md:w-1/3 md:pr-10 mb-10 md:mb-0">
        <div className="md:hidden">
          <button
            className="w-full flex items-center justify-between text-md font-semibold p-3 py-4 border-t border-b"
            onClick={() => setIsOpenOptions(!isOpenOptions)}
          >
             <span className="flex">Table of contents</span>
             <span className="ml-auto transition-transform duration-300 transform" style={{ transform: isOpenOptions ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              {isOpenOptions ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M11.293 7.293a1 1 0 0 1 1.32 -.083l.094 .083l6 6l.083 .094l.054 .077l.054 .096l.017 .036l.027 .067l.032 .108l.01 .053l.01 .06l.004 .057l.002 .059l-.002 .059l-.005 .058l-.009 .06l-.01 .052l-.032 .108l-.027 .067l-.07 .132l-.065 .09l-.073 .081l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002h-12c-.852 0 -1.297 -.986 -.783 -1.623l.076 -.084l6 -6z" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z" />
                </svg>
              )}
            </span>
          </button>
          {isOpenOptions && (
            <ul className="text-gray-700 space-y-2 text-md bg-gray-100 p-4 mt-6 rounded">
              <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/punto-de-venta" className="hover:text-indigo-500 transition-colors duration-300">
                    Punto de venta
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/comercio-electronico" className="hover:text-indigo-500 transition-colors duration-300">
                    E-commerce
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/programa-de-lealtad" className="hover:text-indigo-500 transition-colors duration-300">
                    Lealtad
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/plus" className="hover:text-indigo-500 transition-colors duration-300">
                    Plus
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/kds" className="hover:text-indigo-500 transition-colors duration-300">
                    KDS
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/quioscos" className="hover:text-indigo-500 transition-colors duration-300">
                    Autoservicio
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/marketing" className="hover:text-indigo-500 transition-colors duration-300">
                    Mercadeo
                </Link>
                </li>
            </ul>
          )}
        </div>
        <div className="hidden md:block">
        <h2 className="text-xl font-semibold mb-4">Nuestros Productos</h2>
            <ul className="text-gray-700 space-y-2 text-lg">
            <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/punto-de-venta" className="hover:text-indigo-500 transition-colors duration-300">
                    Punto de venta
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/comercio-electronico" className="hover:text-indigo-500 transition-colors duration-300">
                    E-commerce
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/programa-de-lealtad" className="hover:text-indigo-500 transition-colors duration-300">
                    Lealtad
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/plus" className="hover:text-indigo-500 transition-colors duration-300">
                    Plus
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/kds" className="hover:text-indigo-500 transition-colors duration-300">
                    KDS
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/quioscos" className="hover:text-indigo-500 transition-colors duration-300">
                    Autoservicio
                </Link>
                </li>
                <li>
                <Link onClick={() => window.scrollTo(0, 0)} to="/productos/marketing" className="hover:text-indigo-500 transition-colors duration-300">
                    Mercadeo
                </Link>
                </li>
          </ul>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="w-full md:w-2/3 text-left">
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            En medio de este panorama, contar con un <span className="font-semibold">sistema POS</span> (punto de venta) ya no es un lujo: es una <span className="font-semibold">necesidad estratégica</span>.
        </p>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            Pero no cualquier sistema POS. Lo que tu negocio necesita es una solución <span className="font-semibold">robusta, fácil de usar, adaptada a la realidad salvadoreña</span> y con visión de crecimiento. Eso es <span className="font-semibold">Invu POS</span>.  
            A continuación, te mostramos 8 formas concretas en las que <span className="font-semibold">Invu POS</span> puede ayudarte a crecer y profesionalizar tu operación, sin importar si manejas un restaurante, una tienda, una farmacia o una cadena de negocios.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
            1. <span className="font-semibold">Obtén control total con reportes en tiempo real</span>
        </h2>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
            Una de las principales ventajas de <span className="font-semibold">Invu POS</span> es su capacidad para entregarte información clara y en tiempo real sobre el desempeño de tu negocio. Ya no necesitas esperar al cierre del día o a que tu encargado te pase un resumen. Desde tu celular o computadora puedes saber:
        </p>
        <ul className="list-disc mt-3 space-y-2 ml-6 mb-6">
            <li className="text-xl text-gray-900">Qué producto se está vendiendo más hoy</li>
            <li className="text-xl text-gray-900">Cuánto vendiste por hora, por local o por vendedor</li>
            <li className="text-xl text-gray-900">Cuál es tu ticket promedio</li>
            <li className="text-xl text-gray-900">Qué horario tiene más flujo de clientes</li>
        </ul>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            Esto te permite tomar decisiones inteligentes al instante, como ajustar promociones, reordenar productos o reforzar personal en horas clave. Tener información es tener poder. Y con <span className="font-semibold">Invu POS</span>, ese poder está en tus manos.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
            2. <span className="font-semibold">Control de inventario preciso y automatizado</span>
        </h2>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
            ¿Sabes cuántos productos estás perdiendo cada semana por mal manejo del inventario? El inventario es uno de los puntos más críticos de cualquier negocio, y muchas veces es el más descuidado. Con <span className="font-semibold">Invu POS</span> puedes:
        </p>
        <ul className="list-disc mt-3 space-y-2 ml-6 mb-6">
            <li className="text-xl text-gray-900">Llevar un registro exacto de entradas y salidas</li>
            <li className="text-xl text-gray-900">Recibir alertas automáticas cuando un producto esté por agotarse</li>
            <li className="text-xl text-gray-900">Conocer el costo real de tu inventario y su rotación</li>
            <li className="text-xl text-gray-900">Evitar el sobrestock y el desperdicio</li>
        </ul>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            Además, si manejas recetas (en el caso de restaurantes o cafeterías), <span className="font-semibold">Invu POS</span> descuenta automáticamente los ingredientes utilizados en cada venta. Menos errores. Más control. Y mucha más tranquilidad.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
            3. <span className="font-semibold">Cumple fácilmente con la facturación electrónica salvadoreña</span>
        </h2>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
            La facturación electrónica es una obligación para los negocios en El Salvador, y no todos los sistemas POS están preparados para cumplir con los requerimientos de la Dirección General de Impuestos Internos (DGII). <span className="font-semibold">Invu POS sí lo está.</span>
        </p>
        <ul className="list-disc mt-3 space-y-2 ml-6 mb-6">
            <li className="text-xl text-gray-900">Puedes emitir facturas electrónicas automáticamente, con validación ante DGII</li>
            <li className="text-xl text-gray-900">Tus clientes reciben su comprobante por correo o código QR</li>
            <li className="text-xl text-gray-900">Todo queda respaldado en la nube, con acceso seguro</li>
        </ul>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            Esto no solo te mantiene en regla con el gobierno, sino que te permite dar una imagen más profesional y evitar sanciones. Es el tipo de solución que te ahorra dolores de cabeza desde el día uno.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
            4. Disminuye pérdidas internas y mejora el control del personal
        </h2>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
            Uno de los problemas más comunes en negocios en crecimiento es la falta de control interno. Ya sea por errores humanos, ajustes de caja mal realizados, robos o falta de seguimiento, muchas veces se pierde más dinero del que se cree.
        </p>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-2">
            <span className="font-semibold">Con Invu POS puedes:</span>
        </p>
        <ul className="list-disc mt-3 space-y-2 ml-6 mb-6">
            <li className="text-xl text-gray-900">Asignar roles personalizados a cada usuario (cajero, supervisor, administrador)</li>
            <li className="text-xl text-gray-900">Registrar cada movimiento con hora, fecha y nombre de quien lo ejecutó</li>
            <li className="text-xl text-gray-900">Generar auditorías internas en segundos</li>
            <li className="text-xl text-gray-900">Activar alertas de actividad sospechosa</li>
        </ul>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
        Esto te da un nivel de transparencia y seguridad que simplemente no es posible
        lograr con métodos manuales o sistemas genéricos.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
            5. Mejora la experiencia del cliente y acelera cada venta
        </h2>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
            En un mercado tan competitivo como el salvadoreño, la experiencia del cliente lo es todo. Nadie quiere esperar 15 minutos por su pedido, ni hacer fila por una factura.
        </p>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-2">
            <span className="font-semibold">Invu POS te permite:</span>
        </p>
        <ul className="list-disc mt-3 space-y-2 ml-6 mb-6">
            <li className="text-xl text-gray-900">Imprimir comandas en cocina o barra en tiempo real (ideal para restaurantes)</li>
            <li className="text-xl text-gray-900">Dividir cuentas, añadir productos en la mesa y llevar control por turnos</li>
            <li className="text-xl text-gray-900">Realizar cobros en segundos, con integración de terminales o QR</li>
            <li className="text-xl text-gray-900">Enviar facturas electrónicas por WhatsApp o email</li>
        </ul>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            El resultado: clientes más felices, mayor rotación y más ventas por turno.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
            6. Lanza programas de fidelización y vende más a tus clientes actuales
        </h2>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
            Captar nuevos clientes cuesta. Pero fidelizar a los que ya tienes es mucho más rentable.
        </p>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-2">
            <span className="font-semibold">Con Invu POS puedes:</span>
        </p>
        <ul className="list-disc mt-3 space-y-2 ml-6 mb-6">
            <li className="text-xl text-gray-900">Activar sistemas de puntos por compra</li>
            <li className="text-xl text-gray-900">Ofrecer cupones y promociones personalizadas</li>
            <li className="text-xl text-gray-900">Enviar notificaciones a clientes frecuentes</li>
            <li className="text-xl text-gray-900">Usar una wallet digital conectada a tu marca</li>
        </ul>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            Así no solo vendes una vez, sino muchas veces al mismo cliente. Esto aumenta el ticket promedio y la frecuencia de visita.
        </p>
      </div>
    </div>


   
    <div className="bg-white flex flex-col md:flex-row justify-center items-start mt-14">
      {/* Sidebar - Table of Contents */}
      <div className="w-full md:w-1/3 md:pr-10 mb-10 md:mb-0">
      <div className="bg-white flex flex-col items-start text-left p-6 max-w-md mx-auto">
      {/* Heading */}
      <h2 className="text-3xl font-medium leading-tight mb-4">
      Obtén más información sobre Invu POS
      </h2>
      
      {/* Image */}
      <div className="w-full rounded-lg overflow-hidden mb-6">
        <img
          src="https://images.pexels.com/photos/7682340/pexels-photo-7682340.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
          alt="Business Tools"
          className="w-full h-auto object-cover"
        />
      </div>
      
      {/* Button */}
      <button
        className="px-6 py-3 border border-blue-500 text-blue-500 font-medium rounded-lg hover:bg-blue-100 transition duration-300"
        onClick={() => {
            setIsOpen(true);
        }}
      >
       Empieza Hoy ↗
      </button>
    </div>
      </div>
      
      {/* Main Content */}
      <div className="w-full md:w-2/3 text-left">
        <h2 className="text-4xl font-bold mb-4 mt-10">
            7. Administra tu negocio desde cualquier lugar
        </h2>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
            Sabemos que no siempre puedes estar en el local. Pero eso no significa que debas perder visibilidad. <span className="font-semibold">Invu POS</span> es 100% en la nube, lo que significa que puedes:
        </p>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-2">
            <span className="font-semibold">Invu POS es 100% en la nube, lo que significa que puedes:</span>
        </p>
        <ul className="list-disc mt-3 space-y-2 ml-6 mb-6">
            <li className="text-xl text-gray-900">Ver ventas, inventario y movimientos desde tu celular, estés donde estés</li>
            <li className="text-xl text-gray-900">Recibir alertas en tiempo real sobre ventas grandes, anulaciones o faltantes</li>
            <li className="text-xl text-gray-900">Hacer ajustes o revisar reportes desde casa o incluso desde otro país</li>
        </ul>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            No importa si estás en la tienda, de viaje o descansando. Tu negocio siempre está contigo.
        </p>

        <h2 className="text-4xl font-bold mb-4 mt-10">
            8. Acepta todos los métodos de pago y adáptate al nuevo consumidor
        </h2>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-4">
            Hoy en día, los consumidores quieren pagar como quieran: tarjeta, transferencia, QR, link de pago, incluso wallets digitales. <span className="font-semibold">Invu POS</span> está listo para todo eso y más:
        </p>
        <ul className="list-disc mt-3 space-y-2 ml-6 mb-6">
            <li className="text-xl text-gray-900">Integración con bancos y terminales locales</li>
            <li className="text-xl text-gray-900">Soporte para pagos QR y billeteras electrónicas</li>
            <li className="text-xl text-gray-900">Posibilidad de vender online con link de pago</li>
            <li className="text-xl text-gray-900">Integración con plataformas de delivery</li>
        </ul>
        <p className="text-xl text-gray-900 font-light leading-relaxed mb-6">
            Esto te permite cerrar más ventas y evitar rechazos por limitaciones de cobro.
        </p>
      </div>
    </div>
  </section>

    </>
  )
}

export default Article_the_key_to_scale_your_commerce_in_sv;